export const LEVEL_DEBUG = 'debug';
export const LEVEL_INFO = 'info';
export const LEVEL_WARN = 'warn';
export const LEVEL_ERROR = 'error';
export const LEVEL_CRITICAL = 'critical';

export default {
  [LEVEL_DEBUG]: 1,
  [LEVEL_INFO]: 2,
  [LEVEL_WARN]: 3,
  [LEVEL_ERROR]: 4,
  [LEVEL_CRITICAL]: 5,
};
